import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function MainLayout({ children }) {
  const { user, isAuthenticated, logout, isAdmin } = useAuthStore();
  const navigate = useNavigate();

  // Kiểm tra quyền admin bằng cách gọi hàm isAdmin
  const userIsAdmin = isAdmin();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="main-layout">
      <Header
        user={user}
        isAuthenticated={isAuthenticated}
        isAdmin={userIsAdmin}
        onLogout={handleLogout}
      />

      <main className="main-layout__content">
        <div className="main-layout__container">{children}</div>
      </main>

      <Footer />
    </div>
  );
}
